module.exports = __webpack_public_path__ + "static/TW_MARK_SIX-910efab28f3972b62ccfbefbda57d698.png";